import { ROUTES } from "@nf/constants";
import React from "react";
import dynamic from "next/dynamic";
import { useTranslation } from "next-i18next";

import { ButtonVariant } from "components/Button";

const SettingsSubscriptionButton = dynamic(
  () => import("components/Settings/SettingsSubscriptionButton")
);

export interface ILogoutButtonProps {
  variant: ButtonVariant;
}

export const LogoutButton: React.FC<ILogoutButtonProps> = ({
  variant = "subtle",
}) => {
  const { t } = useTranslation("translations");

  return (
    <SettingsSubscriptionButton variant={variant} href={ROUTES.LOGOUT}>
      {t("web_logout")}
    </SettingsSubscriptionButton>
  );
};

export default LogoutButton;
